import $ from 'jquery';

const initVideo = (el) => { 
    $(el).click(function(e){
        $(e.currentTarget).hide();
        $(e.currentTarget).prev('.js-image').fadeOut('slow');   
        $(e.currentTarget).parent().find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    });
};

export default initVideo;
